import React from 'react';
import { formatNumberPtbr } from 'utils/format-number-ptbr';
import { formatValueInBrazilianCurrency } from 'utils';

import { Skeleton } from '@mui/material';

import {
  IDashboardSummaryItems,
  IItem,
  IRenderSkeletonOrDashboardSummaryItem,
} from './types';

import Box from 'v2/components/UI/Box';
import Icon from 'v2/components/Icon';
import Text from 'v2/components/UI/Text';
import { useWindowSizes } from 'v2/resources/hooks/useWindowSizes';

const DashboardSummaryItems: React.FC<IDashboardSummaryItems> = ({
  fca,
  cost,
  harvestBiomass,
  mainSurvivalText,
  survival,
  loading,
}) => {
  const { isMobile, isTablet } = useWindowSizes();
  const renderItem = ({ title, value, iconName }: IItem) => {
    return (
      <Box
        flexDirection="column"
        background="#fff"
        borderRadius={16}
        padding={20}
        gap={10}
        width={'100%'}
        minWidth={200}
        maxWidth={isMobile || isTablet ? '100%' : '24%'}
        margin={'5px 0'}
      >
        <Icon iconName={iconName} htmlColor="#226A43" size={28} />
        <Box
          alignItems="center"
          justifyContent="space-between"
          width={'100%'}
          flexWrap="wrap"
          gap={10}
        >
          <Text fontSize={16} fontWeight={500}>
            {title}
          </Text>
          <Text fontSize={18} fontWeight={700} color="#226A43">
            {value}
          </Text>
        </Box>
      </Box>
    );
  };

  const renderSkeletonOrDashboardSummaryItem = ({
    loading,
    title,
    value,
    iconName,
  }: IRenderSkeletonOrDashboardSummaryItem) => {
    if (loading) {
      return <Skeleton variant="rectangular" width={'100%'} height={80} />;
    }

    return renderItem({ title, value, iconName });
  };

  return (
    <Box width="100%" gap={'1%'} flexWrap="wrap">
      {renderSkeletonOrDashboardSummaryItem({
        loading,
        iconName: 'QueryStatsOutlined',
        title: 'FCA Médio',
        value: formatNumberPtbr(fca),
        // tooltipTitle:
        //   'O FCA (Fator de Conversão Alimentar) é uma relação entre o consumo de ração e o crescimento dos animais.',
      })}

      {renderSkeletonOrDashboardSummaryItem({
        loading,
        iconName: 'CalculateOutlined',
        title: 'Consumo',
        value: formatValueInBrazilianCurrency(cost),
        // tooltipTitle: `É referente ao gasto registrado no financeiro que você teve ${
        //   filterCycle ? `no ciclo atual` : `em todos os ciclos`
        // }`,
      })}

      {renderSkeletonOrDashboardSummaryItem({
        loading,
        iconName: 'BalanceOutlined',
        title: 'Biomassa',
        value: `${formatNumberPtbr(harvestBiomass) || 0} KG`,
        // tooltipTitle:
        //   'Biomassa despescada: é a soma total despescada de todo o ciclo. Biomassa estimada: é a soma total estimada de todo o ciclo',
      })}

      {renderSkeletonOrDashboardSummaryItem({
        loading,
        iconName: 'FavoriteBorderOutlined',
        title: `${mainSurvivalText}`,
        value: `${formatNumberPtbr(survival) || 0}%`,
        // tooltipTitle: `É o percentual de animais que sobreviveram ${
        //   filterCycle ? `no ciclo atual` : `em todos os ciclos`
        // }.`,
      })}
    </Box>
  );
};

export default DashboardSummaryItems;
